import React from 'react';
import { skills } from '../data/portfolioData';
import { CheckCircle, Cpu, Database, Code2, Terminal } from 'lucide-react';

const Skills = () => {
  const getIcon = (category) => {
    switch(category) {
      case "Développement Web": return <Code2 className="text-primary" size={28} />;
      case "Langages de Programmation": return <Terminal className="text-primary" size={28} />;
      case "Bases de Données": return <Database className="text-primary" size={28} />;
      case "Outils & Technologies": return <Cpu className="text-primary" size={28} />;
      default: return <CheckCircle className="text-primary" size={28} />;
    }
  };

  return (
    <section id="skills" className="py-5 bg-gray-900/50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-primary">Mes compétences</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Technologies et outils que j'utilise
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {skills.map((skillCategory, index) => (
            <div 
              key={index} 
              className="bg-gray-800/30 p-6 rounded-xl border border-gray-700 hover:border-primary/50 transition-all duration-300 hover:transform hover:-translate-y-2"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center">
                  {getIcon(skillCategory.category)}
                </div>
                <h3 className="text-xl font-semibold">{skillCategory.category}</h3>
              </div>
              
              <div className="space-y-3">
                {skillCategory.items.map((skill, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <CheckCircle size={16} className="text-primary" />
                    <span className="text-gray-300">{skill}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default Skills;